@for (toaster of toasters; track toasterById($index, toaster)) {
<app-toastr-message @closeToaster [toaster]="toaster" (closed)="onClosed($event)"> </app-toastr-message>
}
